"use client";
import { useHeader } from "@/hooks/headerContext";
import { usePathname } from "next/navigation";
import { ROUTES } from "@/@core/constants/routes";
import { useSite } from "@/lib/hooks/site";
import { useVenueListPage } from "@/hooks/listPageContext";
import { useTranslation } from "@/hooks/translationContext";
import { useNearbyVenue } from "@/hooks/nearbyVenueContext";
import { useHeaderTitle } from "@/hooks/useHeaderTitle";

export default function HeaderLocationClient() {
  const { venue, district, service } = useHeader();
  const { t } = useTranslation();
  const pathname = usePathname();
  const site = useSite();
  const { isVenueListPage } = useVenueListPage();
  const header = useHeader();
  const { nearbyVenuesCount } = useNearbyVenue();
  const { title } = useHeaderTitle();

  const isEmpty =
    venue.length > 0 ||
    district?.title?.length > 0 ||
    service?.title?.length > 0;

  const i18nTags = () => {
    return {
      venue,
      service: service?.title,
      city: site.city_relation.title,
      district: district?.title,
      totalVenueCount: header.dataCount.venues + nearbyVenuesCount,
      nearbyVenueCount: nearbyVenuesCount,
      venueCount: header?.dataCount?.venues,
    };
  };

  const replaceKey = (key: string) => {
    return t(key, i18nTags());
  };

  const descriptions = {
    [ROUTES.CAMPAIGNS]: (
      <span className="text-gray-400 text-[10px] font-medium">
        Farklı Semt ve Hizmetlerin Kampanyaları için Yukarıdan Arama Yapınız.
      </span>
    ),
    [ROUTES.EVENTS]: (
      <span className="text-gray-400 text-[10px] font-medium">
        Farklı Semt ve Hizmetlerin Etkinlikleri için Yukarıdan Arama Yapınız.
      </span>
    ),
  };

  const venueDescriptions = {
    venue: (
      <span className="text-gray-400 text-[10px] font-medium">
        {replaceKey("search-title-description-venue")}
      </span>
    ),
    [ROUTES.CAMPAIGNS]: (
      <span className="text-gray-400 text-[10px] font-medium">
        {replaceKey("search-title-description-campaign")}
      </span>
    ),
    [ROUTES.EVENTS]: (
      <span className="text-gray-400 text-[10px] font-medium">
        {replaceKey("search-title-description-event")}
      </span>
    ),
  };

  const getDescription = () => {
    return descriptions[pathname] || "";
  };

  const getVenueDescription = () => {
    if (isVenueListPage) return venueDescriptions.venue;

    return venueDescriptions[pathname] || "";
  };

  const hasContent =
    title?.trim() || isEmpty || venue?.trim() || pathname === ROUTES.ALL_COMPANIES;

  if (!hasContent) return null;

  return (
    <div className="flex flex-col gap-2">
      {title && (
        <div className="flex gap-1">
          <h1 className="text-primary text-[20px] font-bold tracking-wider">
            {title}
          </h1>
        </div>
      )}

      {isEmpty && <>{getDescription()}</>}

      {venue && <>{getVenueDescription()}</>}

      {pathname === ROUTES.ALL_COMPANIES && (
        <span className="text-gray-400 text-[10px] font-medium">
          {replaceKey("search-title-description-company-list")}
        </span>
      )}
    </div>
  );
}
